import { propertyFeatureApi } from 'src/api';
import { IPropertiesResponseWithPage } from 'src/ts/interfaces';

const api = {
  getAll: async (propertyId: any) => {
    const response = await propertyFeatureApi.getFeatures(propertyId);
    return response as unknown as IPropertiesResponseWithPage;
  }
};

export default api;
